import { render, staticRenderFns } from "./CreateCourseForm.vue?vue&type=template&id=2383f03e&scoped=true&"
import script from "./CreateCourseForm.vue?vue&type=script&lang=js&"
export * from "./CreateCourseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383f03e",
  null
  
)

export default component.exports